import { LogEntity, logger } from '@fiverr-private/obs';
import { addError } from '@fiverr-private/monicore';

/**
 * Handles CSR errors.
 * @param error The error to handle.
 * @param componentName The component's name.
 * @param entryName The component's entry name.
 */
export const handleError = (error: unknown, componentName: string, entryName: string) => {
    const description = `Layout component: ${componentName}, failed on entry: ${entryName}.`;
    const errorName = `layout.CSR.${componentName}.${entryName}`;

    logger.error(
        error as LogEntity,
        {
            description,
            componentName,
            entryName,
            package: '@fiverr-private/layout-sdk'
        }
    );
    addError(errorName);
};
